module.exports = {
    environment: process.env.ELEVENTY_ENV,
    name: "Polity Ordnance Street",
    url: process.env.ELEVENTY_ENV === 'dev' ? 'https://develop--polity-ordnance-street.netlify.app' : 'https://ordnancestreet.info',

    base: {
        "contact_address": "Polity Communication Ltd, 4 Holtwhite Avenue, Enfield, Middlesex EN2 0RS",
        "contact_number": "0800 246 5890",
        "contact_email": "contact@ordnancestreet.info"
    },

    meta: {
        "defaultSocialImage": "/assets/images/social.jpg",
        "author": "Polity Communications Ltd",
        "description": "Residential-led regeneration proposals for the former St John Fisher Catholic Comprehensive School site  in Ordnance Street, Chatham have now been submitted to Medway Council following local community consultation. This consultation website has been launched on behalf of Eutopia Homes, the new owners of the site to help local residents, businesses and other interest groups find out more about the emerging plans and provide their feedback.",
        "gtag": "G-K1WELZLP8E",
        "gtm": "GTM-MKCPH3C6"
    },

    form: {
        "feedback": {
            "catcher_id": "ec4c28b765493a1e33ff11226fa51bd3",
            "recaptcha": "6LfCNrYUAAAAAOW8mR1JjCFiVHQsv0F1pNjOpP6b",
            "honeypot": "df73e1b2e57bfb5f43350775ccabefea"
        }
    },

    downloads: [
        {
            "title": "Architect's presentation",
            "url": "/assets/images/pdfs/architects-presentation.pdf"
        }
    ],

    // Bugsnag API Key
    bugsnagApiKey: 'a416987a86e7b664e8fd1862fb1c4c02',

    // Marker.io Key - replace this default key
    marker_io: ''
};